module.exports = __webpack_public_path__ + "img/map-layer-add.7794de00.png";